import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface GetFinancialParams {
  pageSize: number;
  page: number;
  cdTerritory: string;
}

export const getFinancialByTerritory = async (params: GetFinancialParams) => {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);
  const { stKey } = userLogged.company;

  const query = qs.stringify({ ...params, tokenKey: stKey });

  return apiConfig
    .get(`api/Territory/get-all-tickets-by-territory?${query}`)
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, err }));
};
